"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      form: {
        introduce: {
          foot_text: '名额有限，领取机会',
          modal_title: '马上加入我们，开启赚钱红利',
          modal_btntext: '立即提交了解详情'
        },
        info_type: -1,
        img_url: []
      },
      id: this.$route.query.id
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    }
  },
  mounted: function mounted() {
    if (this.id > 0) this.getInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('commonapi/signin/detail', {
        id: this.id
      }).then(function (res) {
        var img_url = [];
        res.img_url = res.img_url ? JSON.parse(res.img_url) : [];
        for (var i in res.img_url) {
          img_url.push({
            url: res.img_url[i]
          });
        }
        res.img_url = img_url;
        res.introduce = res.introduce ? JSON.parse(res.introduce) : {};
        _this.form = res;
      });
    },
    /**
     * 提交数据
     */
    onSubmit: function onSubmit() {
      var _this2 = this;
      var params = JSON.parse(JSON.stringify(this.form));
      params.img_url = this.arrayKeys(params.img_url, 'url');
      params.introduce = JSON.stringify(params.introduce);
      if (this.id > 0) params.id = this.id;
      this.$post('/signin/save', params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        _this2.$router.push({
          path: '/signup/index'
        });
      });
    }
  }
};